import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import cx from 'classnames';
import Navigation from './Navigation';
import MobileNavigation from './MobileNavigation';
import Footer from './Footer';
import theme from '../../theme/enplus';
import Breakpoint from '../Breakpoint';
import ScrollTopButton from '../ScrollTopButton';
import useStores from '../../utils/useStores';

const useStyles = makeStyles({
  '@global': {
    body: {
      color: `${theme.palette.text.primary} !important`,
    },
  },
  breakpoint: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: theme.spacing(),
    zIndex: 9999,
  },
  minHeight: {
    minHeight: `calc(100vh - 96px - 216px - 112px)`,
  },
  wrap: {
    ...theme.mixins.maxWidth(),
  },
});

const Layout = props => {
  const { uiStore } = useStores();
  const { children, hideNavPhotoEdge, darkFooter, hideFooter } = props;
  const classes = useStyles({ theme });
  return (
    <React.Fragment>
      <Hidden smDown>
        <Navigation context={uiStore.context} hideEdge={hideNavPhotoEdge} />
      </Hidden>
      <Hidden mdUp>
        <MobileNavigation
          context={uiStore.context}
          hideEdge={hideNavPhotoEdge}
        />
      </Hidden>
      {props.maxWidth ? (
        <div className={cx(classes.wrap, classes.minHeight)}>{children}</div>
      ) : (
        <div className={classes.minHeight}>{children}</div>
      )}
      {!hideFooter && <Footer dark={darkFooter} context={uiStore.context} />}
      <Breakpoint />
      <ScrollTopButton />
    </React.Fragment>
  );
};

Layout.defaultProps = {
  maxWidth: false,
  hideNavPhotoEdge: false,
  darkFooter: false,
  hideFooter: false,
};

export default Layout;
